module.exports = __webpack_public_path__ + "img/lewis-hamilton.8120c12e.png";